<template>
  <ul class="CartItem__Options" v-show="display">
    <li class="CartItem__Option" v-for="option in props.options">
      <p class="p5">{{ option.name }}: {{ option.value }}</p>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
});

const display = computed(() => {
  const options = Array.from(props.options) ?? [];
  const searchForDefaults = options.filter((option) => option.name.includes('Title'));
  return searchForDefaults.length <= 0;
});
</script>
